import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import {Box, Button} from '@mui/material';
import '../Demo.scss';
import {ArrSearchProgressDialog} from '../../../components/common/arr-search-progress-dialog/ArrSearchProgressDialog';
import {t} from 'i18next';

const SearchProgressDialog: React.FC = () => {
  const [open, setOpen] = useState(false);

  return (
    <Box className="demo-page modal-demo">
      <h1>Search Progress Dialog</h1>
      <hr />
      <Link to="/demo" className="link">
        Return
      </Link>
      <hr />
      <Box className="button-row">
        <Button
          variant="contained"
          onClick={() => setOpen(true)}
          data-testid="search-progress-dialog-open-search-progress-dialog-button"
        >
          Open Search Progress Dialog
        </Button>
      </Box>
      <Box>
        <ArrSearchProgressDialog
          showModal={open}
          title={t('common.arrSearchProgressDialog.title')}
          description={t('common.arrSearchProgressDialog.description')}
          buttons={[
            {
              id: '1',
              label: t('common.arrSearchProgressDialog.waitForAllResults'),
              onClick: () => setOpen(false),
              variant: 'primary',
              dataTestId: 'spd-wait-btn',
            },
            {
              id: '2',
              label: t(
                'common.arrSearchProgressDialog.waitForPureHitResultsOnly'
              ),
              onClick: () => setOpen(false),
              variant: 'secondary',
              dataTestId: 'spd-resultonly-btn',
            },
            {
              id: '3',
              label: t(
                'common.arrSearchProgressDialog.notifyMeWhenResultsAreDone'
              ),
              onClick: () => setOpen(false),
              variant: 'secondary',
              dataTestId: 'spd-done-btn',
            },
          ]}
          onClose={() => setOpen(false)}
        ></ArrSearchProgressDialog>
      </Box>
    </Box>
  );
};

export default SearchProgressDialog;
